<template>
  <div>
    <video
      ref="videoPlayer"
      class="video-js vjs-default-skin vjs-big-play-centered" x-webkit-airplay="true" webkit-playsinline="" playsinline="true"
    ></video>
  </div>
</template>

<script>
import 'video.js/dist/video-js.css'

import videojs from 'video.js'
import '@videojs/http-streaming'

export default {
  name: 'VideoPlayer',
  props: {
    options: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  data() {
    return {
      player: null
    }
  },
  mounted() {
    this.player = videojs(
      this.$refs.videoPlayer,
      this.options,
      function onPlayerReady() {
        console.log('onPlayerReady', this)
      }
    )
  },
  beforeDestroy() {
    if (this.player) {
      this.player.dispose()
    }
  }
}
</script>

<style lang="less" scoped>
.video-js {
    width: 100%;
  }
</style>
